import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=23223b09"
import script from "./OrganizationForm.vue?vue&type=script&lang=js"
export * from "./OrganizationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports